/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import last from "lodash/last";
import { useDispatch, useSelector } from "react-redux";
import {
  Breadcrumb,
  Button,
  Col,
  Row,
  Space,
  Table,
  Form,
  Select,
  Modal,
  Input,
  Spin,
  Popconfirm,
  message,
} from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { Option } from "antd/lib/mentions";
import { saveAs } from "file-saver";
import axios from "axios";
import InputNumberFormat from "../common/InputNumberFormat";
import ModalWindow from "../ModalWindow/ModalWindow";
import "./AccountBillsDetails.less";
import { buildQueryStringWithObjectParams, getAccountFullName, round } from "../../lib/utils";
import { toDisplayFormat, toHttpFormat } from "../../lib/utils/formatDate";
import { fetchAgreementByAgrId } from "../../store/slices/agreements";
import {
  fetchPaymentsByAggNotFullPay,
  fetchPaymentsByBillId,
  postBillCover,
  postBillUnCover,
  resetAmountForPaymentGoal,
  setAmountForPaymentGoal,
} from "../../store/slices/payments";
import { fetchBillById, fetchBillsByAggId } from "../../store/slices/bills";
import { paymentConfirmIcon } from "../../lib/icons";
import Message from "../Message/Message";
import { changeBillStatusRoute, getBillsRoute } from "../../lib/routes/bills";
import { checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_ACCOUNT_BILLS_WRITE } from "../../lib/const/permissions";
import SpanNumberFormat from "../common/SpanNumberFormat";
import { ReactComponent as SendIcon } from "../../img/send.svg";
import { ReactComponent as SaveIcon } from "../../img/save.svg";
import loadingStatusCodes from "../../lib/const/loadingStatusCodes";
import { fetchDocumentTemplates } from "../../store/slices/documentTemplates";

const styles = {
  selectTemplate: {
    width: "200px",
  },
  selectFormat: {
    width: "100%",
  },
};

const renderBillAmount = (amount, amountLeft, amountTax) => (
  <Row className="account-bills-details_row-top account-bills-details_row-left">
    <Col span={6}>
      <Row>
        <h4 className="heading-4">Итого к оплате: </h4>
        <span className="account-bills-details_row-left account-bills-details_font-size">
          {SpanNumberFormat({ amount })}
        </span>
      </Row>
    </Col>
    <Col span={6}>
      <Row>
        <h4 className="heading-4">НДС: </h4>
        <span className="account-bills-details_row-left account-bills-details_font-size">
          {SpanNumberFormat({ amount: amountTax })}
        </span>
      </Row>
    </Col>
    <Col span={12}>
      <Row justify="end">
        <h4 className="heading-4">Неоплаченная сумма: </h4>
        <span className="account-bills-details_row-left account-bills-details_font-size">
          {SpanNumberFormat({ amount: amountLeft })}
        </span>
      </Row>
    </Col>
  </Row>
);

const renderTableName = () => (
  <Row className="account-bills-details_row-top account-bills-details_row-bottom account-bills-details_row-left account-bills-details__separate-line">
    <Col span={12}>
      <h4 className="heading-4 account-bills-details__heading">Платежи по счету</h4>
    </Col>
  </Row>
);

const AccountBillsDetails = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { accountId } = useParams();
  const { account, accountEmails } = useSelector((state) => state.accounts);
  const { agreement, agreements } = useSelector((state) => state.agreements);
  const { billInfo } = useSelector((state) => state.bills);
  const { billStatus: billStatuses, paymentSourceTypes } = useSelector(
    (state) => state.rtkDictionaries
  );
  const [modalForm] = Form.useForm();
  const {
    paymentsNotFulledPay,
    paymentsNotFulledPayLoading,
    paymentsBill,
    paymentsBillLoading,
    paymentConfirmLoading,
  } = useSelector((state) => state.payments);

  const { billsFaximileWith } = useSelector((state) => state.settings);
  const { templates, templatesLoading } = useSelector((state) => state?.documentTemplates);
  const [postRequest, setPostRequest] = useState({ formatType: "PDF" });

  const downloadBill = async (id) => {
    try {
      let pathParams = ``;

      if (postRequest?.reportId) {
        pathParams += `${pathParams.length === 0 ? "" : "&"}reportId=${postRequest.reportId}`;
      }
      if (postRequest?.formatType !== "PDF") {
        pathParams += `${pathParams.length === 0 ? "" : "&"}formatType=${postRequest.formatType}`;
      }
      if (pathParams.length > 0) {
        pathParams = `?${pathParams}`;
      }
      const { data } = await axios(`${getBillsRoute()}/${id}/download${pathParams}`, {
        responseType: "blob",
      });
      saveAs(data, `bill${id}.${postRequest.formatType}`);
    } catch (e) {
      Message("Ошибка загрузки счета", e);
    }
  };

  const sendBill = async (id) => {
    message.warning("Идет отправка счета...", 1e5);
    try {
      let pathParams = `?isEmpty=${!billsFaximileWith}`;

      if (postRequest?.reportId) {
        pathParams += `&reportId=${postRequest.reportId}`;
      }
      if (postRequest?.formatType !== "PDF") {
        pathParams += `&formatType=${postRequest.formatType}`;
      }

      await axios.patch(`${getBillsRoute()}/${id}${pathParams}`);
      message.destroy();
      Modal.success({
        content: "Счет отправлен",
      });
    } catch (e) {
      message.destroy();
      Modal.error({
        content:
          "Ошибка отправки счета. Пожалуйста, повторите попытку позже или обратитесь к администратору",
      });
    }
  };

  const renderBillNumberAndDate = (number, id, date, billStatusName) => (
    <Row gutter={["", 10]} className="account-bills-details_row-left">
      <Col span={9}>
        <Row>
          <h4 className="heading-4">Счёт на оплату № </h4>
          <span className="account-bills-details_row-left account-bills-details_font-size">
            {number}
          </span>
        </Row>
      </Col>
      <Col span={5}>
        <Row justify="center">
          <h4 className="heading-4">Дата счёта:</h4>
          <span className="account-bills-details_row-left account-bills-details_font-size">
            {date && date}
          </span>
        </Row>
      </Col>
      <Col span={6}>
        <Row justify="center">
          <h4 className="heading-4">Статус счёта:</h4>
          <span className="account-bills-details_row-left account-bills-details_font-size">
            {billStatusName}
          </span>
        </Row>
      </Col>
      {/* <Col span={4}>
        <Row justify="end">
          <div onClick={() => downloadBill(id)} aria-hidden="true">
            <img src={save} alt="save" />
            <span className="account-bills-details__pdf-label">Скачать</span>
          </div>
        </Row>
      </Col> */}
    </Row>
  );

  const billIdent = last(history.location.search.split("="));
  // const bill = bills.find((item) => item.id === +billId);

  const paymentsSearchParamsNotPaid = {
    page: 0,
    size: 20,
    unpaged: true,
    paymentIsNotFullyPaid: true,
    sort: ["paymentDate", "desc"],
  };

  const paymentsSearchParams = {
    page: 0,
    size: 10,
    orderBy: null,
    direction: null,
    search_txt: "",
    fromDate: "",
    toDate: "",
    dateFromUpdate: "",
    dateToUpdate: "",
    paymentAmount: "",
    unpaged: true,
    param: "",
  };

  const [visibleStornoModal, setVisibleStornoModal] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalPayment, setVisibleModalPayment] = useState(false);
  const [paymentId, setPaymentId] = useState(null);
  const [blockNotFullPaid, setBlockNotFullPaid] = useState(false);

  const [stornoModalForm] = Form.useForm();

  useEffect(() => {
    dispatch(fetchAgreementByAgrId({ agreementId: billInfo?.agreementId }));
    dispatch(fetchBillById({ billId: billIdent }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billInfo?.agreementId]);

  const queryString = `&${buildQueryStringWithObjectParams(paymentsSearchParams)}`;

  useEffect(() => {
    dispatch(fetchPaymentsByBillId({ billId: billIdent, queryString }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryString]);

  const queryStringNotPaid = `&${buildQueryStringWithObjectParams(paymentsSearchParamsNotPaid)}`;

  useEffect(() => {
    if (billInfo?.agreementId)
      dispatch(
        fetchPaymentsByAggNotFullPay({
          agreementId: billInfo?.agreementId,
          queryString: queryStringNotPaid,
        })
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billInfo?.agreementId, queryStringNotPaid]);

  const showModal = () => {
    setVisibleModal(true);
  };

  const showModalPaymentAndSetPaymentId = (id) => {
    setVisibleModalPayment(true);
    setPaymentId(id);
  };

  const handleModalCancel = () => {
    setVisibleModal(false);
    setVisibleModalPayment(false);
  };

  const handleModalResetSearch = () => {
    setVisibleModal(false);
    setVisibleModalPayment(false);
  };

  const disabledBtnByPayStatus = (payStatus, billStatus) => {
    let disabled = false;
    if (payStatus === 2 || billStatus === 6) {
      disabled = true;
    }
    return disabled;
  };

  const tableData =
    billInfo &&
    billInfo?.servicePrepayments.map((item) => ({
      key: uuid(),
      service: item.desc,
      period: [
        {
          id: 1,
          date: item.periodFrom ? toDisplayFormat(item.periodFrom) : "",
        },
        {
          id: 2,
          date: item.periodTo ? toDisplayFormat(item.periodTo) : "",
        },
      ],
      quantity: item.quantity,
      ed: "шт.",
      price: item?.price && round(item.price),
      priceWithoutTax: item?.priceWithoutTax && round(item.priceWithoutTax),
      amount: item?.amount && round(item.amount),
    }));

  const tableDataPayments =
    paymentsBill &&
    paymentsBill?.content
      .filter((el) => {
        if (el?.goals?.length === 0 || el?.goals === undefined) return true;

        const findNotInvoicesGoals = el?.goals?.find((goal) => goal.goalTypeId !== 4);
        return findNotInvoicesGoals;
      })
      .map((payment) => ({
        key: uuid(),
        id: payment.id,
        date: payment.paymentDate ? toDisplayFormat(payment.paymentDate) : "",
        amount: payment?.amount && round(payment.amount),
        amountBill: round(payment?.extra?.toBillAmount),
        confirmDate: payment.confirmDate ? toDisplayFormat(payment.confirmDate) : "",
        sourceTypeName: paymentSourceTypes.find(({ id }) => id === payment.sourceTypeId)?.name,
        documentNumber: payment.info?.documentNumber,
      }));

  const amountBills =
    billInfo && round(billInfo?.servicePrepayments.reduce((sum, cur) => sum + cur.amount, 0));

  const tableModalPayments =
    paymentsNotFulledPay &&
    paymentsNotFulledPay?.content
      .filter((item) => {
        return (
          item.extra.availableAmount > 0 &&
          item.paymentStatusId !== 1 &&
          item.paymentStatusId !== 4 &&
          item.payStatusId !== 2
        );
      })
      .map((payment) => ({
        key: payment.id,
        id: payment.id,
        amount: payment?.amount && round(payment.amount),
        paymentDate: payment.paymentDate ? toDisplayFormat(payment.paymentDate) : "",
        availableAmount: round(payment?.extra?.availableAmount),
        paymentId: payment.id,
        billId: billIdent,
        amountForPaymentGoal: payment.amountForPaymentGoal,
      }));

  const amountToPay =
    paymentsNotFulledPay &&
    round(
      paymentsNotFulledPay?.content.reduce((sum, cur) => sum + Number(cur.amountForPaymentGoal), 0)
    );

  const handlePaymentConfirm = async () => {
    const agreementsIds = agreements.map((item) => item.id);
    const selectedPays =
      paymentsNotFulledPay &&
      paymentsNotFulledPay?.content?.filter((payment) => payment.amountForPaymentGoal !== "");

    const isModalVisible = billInfo?.amountLeft != amountToPay;

    const exportedData = {
      coverBills: await selectedPays.map((item) => ({
        paymentId: item.id,
        billId: billIdent,
        amountForPaymentGoal: item.amountForPaymentGoal,
      })),
      readOnlyBeforeRunStatement: "",
    };
    await dispatch(postBillCover(exportedData));
    dispatch(
      fetchPaymentsByAggNotFullPay({
        agreementId: billInfo && billInfo?.agreementId,
        queryString: queryStringNotPaid,
      })
    );
    await dispatch(fetchPaymentsByBillId({ billId: billIdent, queryString }));
    await dispatch(fetchBillById({ billId: billIdent }));
    await dispatch(fetchBillsByAggId({ aggId: agreementsIds }));
    setVisibleModal(isModalVisible);
    dispatch(resetAmountForPaymentGoal());
    modalForm.resetFields();
  };

  const handlePaymentDisConfirm = async () => {
    setVisibleModalPayment(false);
    const agreementsIds = agreements.map((item) => item.id);
    const exportedData = {
      uncoverBills: [
        {
          paymentId,
          billId: billIdent,
        },
      ],
      readOnlyBeforeRunStatement: "",
    };
    await dispatch(postBillUnCover(exportedData));
    dispatch(
      fetchPaymentsByAggNotFullPay({
        agreementId: billInfo && billInfo?.agreementId,
        queryString: queryStringNotPaid,
      })
    );
    await dispatch(fetchPaymentsByBillId({ billId: billIdent, queryString }));
    await dispatch(fetchBillById({ billId: billIdent }));
    await dispatch(fetchBillsByAggId({ aggId: agreementsIds }));
  };

  const billTableColumns = [
    {
      title: "Наименование",
      dataIndex: "service",
      key: "service",
    },
    {
      title: "Период",
      dataIndex: "period",
      key: "period",
      render: (period) => (
        <>
          {period.map((item) => (
            <div key={item.id}>
              {item.date}
              {`${item.id === 1 ? "-" : ""} `}
            </div>
          ))}
        </>
      ),
    },
    {
      title: "Количество",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Единицы",
      dataIndex: "ed",
      key: "ed",
    },
    {
      title: "Цена без НДС",
      dataIndex: "priceWithoutTax",
      key: "priceWithoutTax",
      render: (priceWithoutTax) => SpanNumberFormat({ amount: priceWithoutTax }),
    },
    {
      title: "Цена с НДС",
      dataIndex: "price",
      key: "price",
      render: (price) => SpanNumberFormat({ amount: price }),
    },
    {
      title: "Сумма",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => SpanNumberFormat({ amount }),
    },
  ];

  const payBillTableColumns = [
    {
      title: "Дата платежа",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Общая сумма платежа",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => SpanNumberFormat({ amount }),
    },
    {
      title: "Номер документа",
      dataIndex: "documentNumber",
      key: "documentNumber",
    },
    {
      title: "Источник платежа",
      dataIndex: "sourceTypeName",
      key: "sourceTypeName",
    },
    {
      title: "Сумма",
      dataIndex: "amountBill",
      key: "amountBill",
      render: (amountBill) => SpanNumberFormat({ amount: amountBill }),
    },
    {
      title: "Дата обработки",
      dataIndex: "confirmDate",
      key: "confirmDate",
    },
    {
      title: "Снять отметку оплаты",
      dataIndex: "",
      key: "pay",
      render: (record) => (
        <div>
          <span
            onClick={(e) => e.stopPropagation()}
            style={{ marginLeft: "50px" }}
            aria-hidden="true"
          >
            {/* eslint-disable-next-line react/button-has-type */}
            <button
              className="button-icon"
              onClick={() => showModalPaymentAndSetPaymentId(record?.id)}
            >
              {paymentConfirmIcon("#86ACD2")}
            </button>
          </span>
        </div>
      ),
    },
  ];

  const paymentModalColumns = [
    {
      title: "Cумма платежа",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => SpanNumberFormat({ amount }),
    },
    {
      title: "Дата платежа",
      dataIndex: "paymentDate",
      key: "paymentDate",
    },
    {
      title: "Доступная сумма",
      dataIndex: "availableAmount",
      key: "availableAmount",
      render: (availableAmount) => SpanNumberFormat({ amount: availableAmount }),
    },
    {
      title: "Сумма к оплате",
      dataIndex: "",
      key: "pay",
      render: (val, record, index) => {
        const handlePaymentAmount = (value) => {
          if (value || value === "") {
            dispatch(setAmountForPaymentGoal({ id: record.id, value }));
          }
          if (Number(value) > Number(record.availableAmount)) {
            setBlockNotFullPaid(true);
          } else {
            setBlockNotFullPaid(false);
          }
        };

        return (
          <Form.Item name={index} style={{ marginBottom: 0 }}>
            <InputNumberFormat
              onChange={handlePaymentAmount}
              allowNegative={false}
              decimalScale={2}
              allowClear
            />
          </Form.Item>
        );
      },
    },
  ];

  const renderStornoModal = () => {
    const closeStornoModal = () => {
      setVisibleStornoModal(false);
      stornoModalForm.resetFields();
    };
    const onFinish = ({ billStatusId, reason }) => {
      closeStornoModal();
      setDataLoading(true);
      const url = changeBillStatusRoute({
        billId: billIdent,
        billStatusId,
        reason,
      });
      axios
        .patch(url)
        .then(() => {
          dispatch(fetchBillById({ billId: billIdent })).then(() => {
            Modal.success({ content: "Статус счета изменен" });
          });
        })
        .catch(() => {
          Modal.error({ content: "Ошибка изменения статуса счета" });
        })
        .finally(() => {
          setDataLoading(false);
        });
    };

    return (
      <Modal
        visible={visibleStornoModal}
        title="Изменение статуса счета"
        okText="Сохранить"
        cancelText="Отменить"
        onCancel={closeStornoModal}
        okType="primary"
        onOk={stornoModalForm.submit}
      >
        <Form form={stornoModalForm} onFinish={onFinish} layout="vertical">
          <Form.Item name="billStatusId" label="Статус" initialValue={7}>
            <Select>
              {billStatuses
                .filter(({ id }) => id !== 6)
                .map(({ id, name }) => (
                  <Select.Option value={id} key={id}>
                    {name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item name="reason" label="Основание действия">
            <Input.TextArea maxLength={650} />
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  // Загрузка шаблонов
  useEffect(() => {
    const params = {
      reportTypeId: billInfo.billTypeId,
      onDate: billInfo?.fromDate ? toHttpFormat(billInfo?.fromDate) : toHttpFormat(moment()),
    };
    dispatch(fetchDocumentTemplates(params));
  }, []);

  const renderSelectTemplates = () => (
    <Select
      placeholder="Выберите шаблон"
      style={styles.selectTemplate}
      loading={templatesLoading === loadingStatusCodes.pending}
      onChange={(value) => {
        setPostRequest({
          ...postRequest,
          reportId: value,
        });
      }}
      allowClear
    >
      {templates &&
        templates.length !== 0 &&
        Array.isArray(templates) &&
        templates?.map((item) => (
          <Option key={uuid()} value={item.id}>
            {item.defaultTemplate ? `${item.name} (по умолчанию)` : item.name}
          </Option>
        ))}
    </Select>
  );

  const renderSelectFormat = () => (
    <Select
      placeholder="Выберите формат"
      defaultValue="PDF"
      onChange={(value) => {
        setPostRequest({
          ...postRequest,
          formatType: value,
        });
      }}
    >
      {[{ value: "PDF" }, { value: "XLSX" }].map((item) => (
        <Option key={uuid()} value={item.value}>
          {item.value}
        </Option>
      ))}
    </Select>
  );

  const fullName = getAccountFullName(account);

  return (
    <div className="account-bills-details">
      <Spin spinning={dataLoading}>
        <Breadcrumb className="breadcrumb">
          <Breadcrumb.Item>
            <Link to="/">Аккаунты</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/accounts/${accountId}/bills`}>Счета</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Детали счёта 1</Breadcrumb.Item>
        </Breadcrumb>

        <Row>
          <h1>Детали счета</h1>
          <Space size="large" className="account-bills-details__header_space">
            <Space>
              Аккаунт:
              <span>{fullName}</span>
            </Space>
            <Space>
              Договор:
              <span>{agreement?.agreementNumber}</span>
            </Space>
          </Space>
        </Row>
        {hasAccess(MENU_ACCOUNT_BILLS_WRITE) && (
          <Row
            align="end"
            style={{ margin: "5px 0px 15px" }}
            className="account-bills-details_row-left"
          >
            <Col span={12}>
              <Row align="start" gutter={[10, 0]}>
                {billInfo?.billStatusId !== 6 && (
                  <Col>
                    <Button
                      type="primary"
                      onClick={() => {
                        setVisibleStornoModal(true);
                      }}
                    >
                      Изменить статус
                    </Button>
                  </Col>
                )}
                <Col>
                  <Button
                    disabled={disabledBtnByPayStatus(billInfo?.payStatusId, billInfo?.billStatusId)}
                    onClick={showModal}
                    type="primary"
                  >
                    Отметить оплату
                  </Button>
                </Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row align="end" gutter={[10, 0]}>
                <Col>{renderSelectFormat()}</Col>
                <Col>{renderSelectTemplates()}</Col>
                <Col>
                  {billInfo?.amount !== 0 && (
                    <>
                      <Popconfirm
                        title={
                          <>
                            <h3>Отправка счета по адресам</h3>
                            <ul className="list_unstyled account-bills-details__list-noPadding">
                              {accountEmails.map((item) => (
                                <li key={uuid()}>{item.email}</li>
                              ))}
                            </ul>
                          </>
                        }
                        placement="left"
                        okText="Отправить"
                        cancelText="Отмена"
                        icon=""
                        onCancel={(e) => e.stopPropagation()}
                        onConfirm={(e) => {
                          e.stopPropagation();
                          sendBill(billIdent);
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <Button
                          icon={<SendIcon />}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          className="button-icon"
                        />
                      </Popconfirm>
                      <Button
                        icon={<SaveIcon />}
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadBill(billIdent);
                        }}
                        className="button-icon"
                      />
                    </>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        )}
        {renderBillNumberAndDate(
          billInfo?.billNumber,
          billIdent,
          billInfo ? toDisplayFormat(billInfo?.fromDate) : "",
          billStatuses.find((billItem) => billItem.id === billInfo?.billStatusId)?.name || "",
          billInfo?.amount
        )}
        <Table size="small" columns={billTableColumns} dataSource={tableData} pagination={false} />
        {renderBillAmount(amountBills, round(billInfo?.amountLeft), billInfo?.amountTax)}
        {renderTableName()}
        <Table
          size="small"
          className="account-bills-details__table"
          loading={checkIsLoading(paymentsBillLoading)}
          columns={payBillTableColumns}
          dataSource={tableDataPayments}
          pagination={false}
        />
        <ModalWindow
          visible={visibleModal}
          title="Отметить оплату"
          handleSubmit={handlePaymentConfirm}
          handleCancel={handleModalCancel}
          handleReset={handleModalResetSearch}
          width={700}
          cancelTextButton="Отмена"
          submitTextButton="Подтвердить"
          className="modal-bill-pay"
          submitButtonLoading={checkIsLoading(paymentConfirmLoading)}
          disabled={
            Number(amountToPay) === 0 ||
            Number(round(billInfo?.amountLeft)) < Number(amountToPay) ||
            blockNotFullPaid === true
          }
        >
          <Row className="account-bills-details_row-left">
            <Col span={12}>
              <h4 className="heading-4">
                Сумма счета: <span>{SpanNumberFormat({ amount: amountBills })}</span>
              </h4>
            </Col>
            <Col span={12}>
              <h4 className="heading-4">
                Неоплаченная сумма:{" "}
                <span>{SpanNumberFormat({ amount: billInfo?.amountLeft })}</span>
              </h4>
            </Col>
          </Row>
          <Form form={modalForm}>
            <Table
              size="small"
              columns={paymentModalColumns}
              loading={checkIsLoading(paymentsNotFulledPayLoading)}
              dataSource={tableModalPayments}
              pagination={false}
              scroll={{ y: 300 }}
            />
          </Form>
          <Col span={24} style={{ marginTop: "10px" }}>
            {Number(round(billInfo?.amountLeft)) < Number(amountToPay) || blockNotFullPaid ? (
              <span style={{ color: "#ff0714" }}>
                Cумма для оплаты не может превышать неоплаченную сумму или доступную сумму
              </span>
            ) : (
              ""
            )}
            <h4 className="heading-4">
              Итого сумма для оплаты: <span>{SpanNumberFormat({ amount: amountToPay })}</span>
            </h4>
          </Col>
          <Col span={24}>
            <h4 className="heading-4">
              Итого неоплаченная сумма по счёту:{" "}
              <span>{SpanNumberFormat({ amount: billInfo?.amountLeft - amountToPay })}</span>
            </h4>
          </Col>
        </ModalWindow>
        <ModalWindow
          visible={visibleModalPayment}
          handleSubmit={() => handlePaymentDisConfirm()}
          handleCancel={handleModalCancel}
          handleReset={handleModalResetSearch}
          cancelTextButton="Отмена"
          submitTextButton="Далее"
        >
          <Row align="center">
            <Col span={14} style={{ textAlign: "center", fontSize: "16px", lineHeight: 1.4 }}>
              Вы действительно хотите снять отметку оплаты ?
            </Col>
          </Row>
        </ModalWindow>
        {renderStornoModal()}
      </Spin>
    </div>
  );
};

export default AccountBillsDetails;
